// Mock data for Mainet Makelaars landing page

export const heroData = {
  headline: "If it's worth insuring, it's worth insuring properly.",
  subHeadline: "Specialized risk management for complex portfolios and commercial ventures.",
  ctaText: "Request Risk Audit"
};

export const hookData = {
  headline: "Your portfolio isn't generic. Your risk strategy shouldn't be either.",
  body: "We move beyond standard policy schedules to structure a comprehensive defense around your wealth and operations."
};

export const servicesData = [
  {
    id: 1,
    title: "Asset Protection",
    focus: "Specialized Coverage for Valuable Assets",
    description: "Whether it's equipment, collections, vehicles, inventory, or machinery that matters to you—we build protection that goes beyond what standard policies cover. Your assets deserve precision coverage."
  },
  {
    id: 2,
    title: "Liability & Litigation",
    focus: "Legal defense and reputation",
    description: "Comprehensive directors' and officers' liability, professional indemnity, and reputation protection structured for individuals and entities under scrutiny."
  },
  {
    id: 3,
    title: "Business Continuity",
    focus: "Operational survival",
    description: "Risk transfer solutions ensuring your operations withstand disruption. From supply chain failures to catastrophic events, we structure resilience."
  }
];

export const companyInfo = {
  name: "Mainet Makelaars",
  regulatory: "Authorized Financial Services Provider FSP: 2562",
  address: "37 Reier Road, Roodeplaat, Pretoria, 0035",
  phone: "061 410 3081",
  email: "eugene@mainet.co.za"
};

export const navigationLinks = [
  { id: 1, label: "Services", href: "#services" },
  { id: 2, label: "About", href: "#about" },
  { id: 3, label: "Contact", href: "#contact" }
];
